import SocialProfilePopup, {
  SocialProfilePopupStateProps,
  SocialProfilePopupDispatchProps,
} from 'components/features/socialFeed/SocialProfilePopup/SocialProfilePopup'
import { State } from 'interfaces/state'
import { feedSocialProfileSelector } from 'selectors/feedSelectors'
import { connectOptionally, OptionalRendererProps } from 'tangle-shared'
import { MapDispatchToPropsFunction } from 'react-redux'
import { changeSocialProfileStepActionCreator } from 'actions/feedActions'
import { composeExecCommandActionCreator } from 'actions/feedComposeActions'
import { ComposeId } from 'interfaces/feed'
import { cropperInputSelector } from 'selectors/cropperSelectors'
import { createOptionalRenderer } from 'helpers/tangleSharedHelpers'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'

const optionalRenderer = createOptionalRenderer<SocialProfilePopupStateProps>()
const mapStateToProps = (state: State): OptionalRendererProps<SocialProfilePopupStateProps> => {
  const isAuthenticated = isAuthenticatedSelector(state)
  if (!isAuthenticated) {
    return optionalRenderer.fallback()
  }

  const { step, focusComposeId } = feedSocialProfileSelector(state)
  const image = cropperInputSelector(state)

  if (!step) {
    return optionalRenderer.fallback()
  }

  return optionalRenderer.render({
    step: image ? 'cropper' : step,
    focusComposeId,
  })
}

const mapDispatchToProps: MapDispatchToPropsFunction<SocialProfilePopupDispatchProps> = (dispatch) => ({
  onComplete: (focusComposeId?: ComposeId) => {
    dispatch(changeSocialProfileStepActionCreator(null))
    if (focusComposeId) {
      dispatch(composeExecCommandActionCreator({
        composeId: focusComposeId,
        command: {
          type: 'focus',
        },
      }))
    }
  },
  onClose: () => {
    dispatch(changeSocialProfileStepActionCreator(null))
  },
})

const SocialProfilePopupContainer = connectOptionally<
  SocialProfilePopupStateProps, SocialProfilePopupDispatchProps
>(mapStateToProps, mapDispatchToProps)(SocialProfilePopup)

export default SocialProfilePopupContainer
